import React, { useState, useEffect } from "react";
import imgone from "../assets/img/image-one.png";
import { useLocation } from "react-router-dom";

/**
 * Area above the page's content area
 * @returns {JSX.Element}
 * @component
 */
const Bodytop = () => {
  const [headingmain, setHeadingMain] = useState("Home");
  const [heading, setHeading] = useState("");
  const [headingpara, setHeadingpara] = useState("");
  const { pathname } = useLocation();

  useEffect(() => {
    updateHeading();
  }, []);

  useEffect(() => {
    updateHeading();
  }, [pathname]);

  const updateHeading = () => {
    if (window.location.pathname === "/home") {
      setHeading("Home Management");
      setHeadingpara("Banner");
      setHeadingMain("Home");
    }

    if (window.location.pathname === "/joinsmfa") {
      setHeading("Home Management");
      setHeadingpara("Join");
      setHeadingMain("Home");
    }
    if (window.location.pathname === "/mission") {
      setHeading("Home Management");
      setHeadingpara("Mission");
      setHeadingMain("Home");
    }

    if (window.location.pathname === "/getinvolve") {
      setHeading("Home Management");
      setHeadingpara("Getting Involved");
      setHeadingMain("Home");
    }

    if (window.location.pathname === "/about") {
      setHeading("About Management");
      setHeadingpara("About Banner");
      setHeadingMain("About");
    }
    if (window.location.pathname === "/contentmanagement") {
      setHeading("About Management");
      setHeadingpara("Content Management");
      setHeadingMain("About");
    }

    if (window.location.pathname === "/directors") {
      setHeading("About Management");
      setHeadingpara("Boards of Directors");
      setHeadingMain("About");
    }

    if (window.location.pathname === "/meeting") {
      setHeading("Meeting Management");
      setHeadingpara("Meeting Banner");
      setHeadingMain("Meeting");
    }

    if (window.location.pathname === "/meetings") {
      setHeading("Meeting Management");
      setHeadingpara("Meeting Management");
      setHeadingMain("Meeting");
    }
    if (window.location.pathname === "/meeting-registrants") {
      setHeading("Meeting Management");
      setHeadingpara("Meeting Registrants");
      setHeadingMain("Meeting");
    }
    if (window.location.pathname === "/benefitsmembership") {
      setHeading("Membership Management");
      setHeadingpara("Benefits Of Membership");
      setHeadingMain("Membership");
    }

    if (window.location.pathname === "/memberhighlight") {
      setHeading("Membership Management");
      setHeadingpara("Membership Highlight");
      setHeadingMain("Membership");
    }

    if (window.location.pathname === "/membershipcategories") {
      setHeading("Membership Management");
      setHeadingpara("Membership Categories");
      setHeadingMain("Membership");
    }

    if (window.location.pathname === "/getinvolved") {
      setHeading("Membership Management");
      setHeadingpara("Get involved");
      setHeadingMain("Membership");
    }

    if (window.location.pathname === "/members") {
      setHeading("Membership Management");
      setHeadingpara("Members");
      setHeadingMain("Members");
    }

    if (window.location.pathname === "/contact") {
      setHeading("Contact Management");
      setHeadingpara("Contact");
      setHeadingMain("Contact");
    }

    if (window.location.pathname === "/patients") {
      setHeading("Patients Management");
      setHeadingpara("patients");
      setHeadingMain("Patients");
    }

    if (window.location.pathname === "/educationmeetingplanningcommittee") {
      setHeading("Committees Management");
      setHeadingpara("Education and meeting planning Committee");
      setHeadingMain("Committees");
    }

    if (window.location.pathname === "/financemembershipcommittee") {
      setHeading("Committees Management");
      setHeadingpara("Finance Membership Committee");
      setHeadingMain("Committees");
    }

    if (window.location.pathname === "/researchcommittee") {
      setHeading("Committees Management");
      setHeadingpara("Research Committee");
    }

    if (window.location.pathname === "/intersocietycommittee") {
      setHeading("Committees Management");
      setHeadingpara("Intersociety Committee");
      setHeadingMain("Committees");
    }
    if (window.location.pathname === "/committeemembers") {
      setHeading("Committees Management");
      setHeadingpara("Committee Members");
      setHeadingMain("Committees");
    }

    if (window.location.pathname === "/affiliates") {
      setHeading("Affiliates Management");
      setHeadingpara("Affiliates");
      setHeadingMain("Affiliates");
    }
    if (window.location.pathname === "/site") {
      setHeading("Site Management");
      setHeadingpara("Site");
      setHeadingMain("Site");
    }
    if (window.location.pathname === "/comingsoon") {
      setHeading("Coming Soon Management");
      setHeadingpara("Coming Soon");
      setHeadingMain("Coming Soon");
    }
    if (window.location.pathname === "/fiestasessions") {
      setHeading("Resources Management");
      setHeadingpara("Fiesta Sessions");
      setHeadingMain("Resources");
    }
    if (window.location.pathname === "/privacypolicy") {
      setHeading("Privacy Policy Management");
      setHeadingpara("Privacy Policy");
      setHeadingMain("Privacy Policy");
    }
    if (window.location.pathname === "/cancelpolicy") {
      setHeading("Cancel Policy Management");
      setHeadingpara("Cancel Policy");
      setHeadingMain("Cancel Policy");
    }
  };

  return (
    <div className="main-body-sec content">
      <div className="container-fluid">
        <div className="row">
          <div className="bg-main-body">
            <div className="col-md-12">
              <div className="content-left">
                <h1>{heading}</h1>
                <p>
                  {headingmain} <span>/</span> {headingpara}
                </p>
              </div>
              <div className="content-right">
                <img src={imgone} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bodytop;
